import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link,  } from "react-router-dom";
import store from "../../store";

import useHttp from "../../hooks/useHttp";
import LoaderImg from "../../assets/media/loader.gif";
import "../../assets/css/load-list-page.css";

import { FAVORITE_LIST_GET, REMOVE_FAVORITE_CARRIER_URL } from "../../utils/api-ends";
import Rating from "../../components/Rating";
import { favoriteListValue, } from "../../store/slices/favorite";


const Favorite = () => {

	const { sendRequests } = useHttp();
	const { isLoading: isLoadingFavoriteCarrier, sendRequests: loadFavoriteCarrierRequest, } = useHttp();
	const favoriteList = useSelector((state) => state.favorite);

	useEffect(() => {
        const response = (data) => {
        	//setAllValue(data)
			store.dispatch(
		        favoriteListValue({
		          favoriteValue: data,
		        })
		    );
        };
        // Send request to get Favorite list
        loadFavoriteCarrierRequest(
          {
            url: FAVORITE_LIST_GET,
            method: "GET",
          },
          response
        );
	}, [loadFavoriteCarrierRequest]);


	const removeCarrier = (e) => {

		const carrierId = e.target.getAttribute("data-carrierid")
		const response = (data) => {
			const favoriteArr = favoriteList.favoriteList.filter(function(item) {
              return item.id !== parseInt(carrierId)
          }) 
			store.dispatch(
	            favoriteListValue({
	                favoriteValue: favoriteArr,
	            })
	        )
		}

		sendRequests(
          {
            url: REMOVE_FAVORITE_CARRIER_URL(carrierId),
            method: "DELETE",
          },
          response
        );
	}


  return (
    <>


     <section id="user-favorite-header">
        <div className="container">
            <div className="user-favorite-tittle">
                <p className="large-text">
                    Favorite List {/* (09) */}
                </p>
            </div>
        </div>
    </section> 


      
    	<section id="user-favorite-list">
        <div className="container">
          <div className="row">
            {isLoadingFavoriteCarrier ? (
              <div className="loader d-flex justify-content-center mb-5 mt-5">
                <img style={{ width: "35px" }} src={LoaderImg} alt="" />
              </div>
            ) : ( 
              <>
               {favoriteList.favoriteList?.map((value, index) => ( 
                  <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                    <div className="user-info-and-load-details-card">
                        <div className="loader-user-info mb-3">
                        <div className="loader-user-img">
                          <img src={value.profile_picture} alt="" />
                        </div>

                        <div>
                          <h1 className="large-text">{value.name}</h1>
                          <div className="user-rating">
                            <Rating rating={value.avg_review_rating} />
                            <span>
                              (
                              {value.avg_review_rating != null
                                ? value.avg_review_rating
                                : 0}
                              )
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="user-extra-info">
                        <h1 className="large-text"> Total Loads: Vehicle </h1>
                        <div className="user-extra-info-box">
                          <span>Carrier Type:</span>
                          <span>{value.carrier_type_value}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Load Type:</span>
                          <span>{value.load_type_value}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>State/Region:</span>
                          <span>{value.state}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>City</span>
                          <span>{value.city}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Zip Code</span>
                          <span>{value.zip_code}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Address</span>
                          <span>{value.street_address}</span>
                        </div>
                      </div>

                      <div className="multiple-btn mt-3">
                          <Link to={`/${value.user_id}/user-profile-information/`} className="add-favorite-carrier">Expand</Link>
                          <button onClick={removeCarrier} data-carrierid={value.id} className="remove-favorite-carrier">Remove</button>
                      </div>

                    </div>
                  </div>
                ))} 

               {favoriteList.favoriteList?.length === 0 && (
	              <div className="col-xl-12 col-md-12">
	                <div className="no-data-found">
	                  <h1 className="large-text">No Favorite Carrier Found</h1>
	                </div>
	              </div>
	            )}
              </>
             )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Favorite;
